import { Tooltip } from '@anwb/poncho/components/tooltip';
import { trackEvent } from '@anwb/poncho/utilities/tracking';

const handleTooltipClick = (fieldName: string) => () => {
	trackEvent({
		event: 'user_interaction',
		type: 'form',
		component: 'pop-up',
		field: fieldName,
		action: 'click',
		actionValue: 'open',
	});
};

export const ContractOverviewItems = [
	{ key: 'Onderhoud, banden en reparaties', value: 'Inclusief' },
	{ key: 'Auto- en inzittendenverzekering', value: 'Inclusief' },
	{ key: 'Wegenbelasting', value: 'Inclusief' },
	{
		key: 'Pechhulp',
		value: (
			<>
				Wegenwacht Europa Standaard{' '}
				<Tooltip onClick={handleTooltipClick('pechhulp')}>
					Heb je al Wegenwacht Service? Dan keren wij het reeds betaalde bedrag naar rato aan je uit
					en staat gedurende het leasecontract Wegenwacht Europa Standaard als korting op je
					factuur. Het ANWB-lidmaatschap à € 17,- per jaar en de eventuele meerprijs voor
					uitbreidingen zijn wel voor eigen rekening.
				</Tooltip>
			</>
		),
	},
	{ key: 'ANWB Lidmaatschap', value: '€ 17,- per jaar' },
	{ key: 'Aflevering', value: 'Ophalen bij de aangewezen autodealer' },
	{ key: 'Krediet toetsing', value: 'Ja' },
	{
		key: 'BKR registratie',
		value: (
			<>
				Ja{' '}
				<Tooltip onClick={handleTooltipClick('bkr-registratie')}>
					Een BKR-registratie is volgens het keurmerk Private Lease verplicht en is bedoeld om de
					consument te beschermen. Ayvens (voorheen LeasePlan) zal het volgende bedrag doorgegeven
					aan BKR: Leaseprijs x looptijd. Met een vooruitbetaling kun je dit bedrag verlagen.
				</Tooltip>
			</>
		),
	},
	{
		key: 'Aanpassing contractperiode',
		value: (
			<>
				Ja{' '}
				<Tooltip onClick={handleTooltipClick('aanpassing-contractperiode')}>
					Als je eerder wilt stoppen, rekenen we met de werkelijke looptijd en met het maandtarief
					wat daarbij hoort. Je betaalt nooit meer dan wat je anders betaald zou hebben. Wel houden
					we de minimale gebruiksperiode van 12 maanden aan. De nieuwe leaseprijs geldt vanaf het
					begin van de leaseovereenkomst en je betaalt het verschil.{' '}
				</Tooltip>
			</>
		),
	},
	{
		key: 'Aanpassing kilometers',
		value: (
			<>
				Ja{' '}
				<Tooltip onClick={handleTooltipClick('aanpassing-kilometers')}>
					Rij je meer of minder kilometers dan je hebt afgesproken? Hierdoor kun je in een andere
					bundel vallen en betaal je het tarief dat bij die bundel hoort. Indien nodig stellen we
					jaarlijks, in overleg met jou, je bundel bij. Bij een lagere bundel krijg je het verschil
					terug, bij een hogere bundel betaal je het verschil bij.{' '}
				</Tooltip>
			</>
		),
	},
	{ key: 'Opbouw schadevrije jaren', value: 'Ja' },
	{
		key: 'Eigen risico',
		value: (
			<>
				€ 300, te verlagen
				<Tooltip onClick={handleTooltipClick('opbouw-schadevrije-jaren')}>
					Voor aanvang van het leasecontract kun je aangeven of je de standaard eigen bijdrage van €
					300,- per schadegeval dat niet verhaalbaar is wilt wijzigen. Je kan het verlagen naar €
					150,- of helemaal afkopen. Dit verhoogt dan wel je maandbedrag. Na je aanvraag kan Ayvens
					(voorheen LeasePlan) je hierover informeren.{' '}
				</Tooltip>
			</>
		),
	},
	{
		key: 'Opzeggen bij calamiteiten',
		value: (
			<>
				Ja{' '}
				<Tooltip onClick={handleTooltipClick('opzegging-bij-calamiteiten')}>
					Bij overlijden, gedwongen ontslag, arbeidsongeschiktheid, scheiding en ontbinding van
					geregistreerd partnerschap kun je het contract kostenloos opzeggen.
				</Tooltip>
			</>
		),
	},
];
